import { jsx, jsxs } from "react/jsx-runtime";
import { Drawer } from "@crehana/ui";
import clsx from "clsx";
import { useMainMenuContext } from "../hooks/index.js";
import DrawerHeader from "./DrawerHeader.js";
const MainMenuDrawer = ({ title, isOpen, onDismiss, onGoBack, position, children, isNew, className })=>{
    const { theme } = useMainMenuContext();
    return /*#__PURE__*/ jsxs(Drawer, {
        open: isOpen,
        onDismiss: onDismiss,
        position: position,
        className: clsx(className, 'flex flex-col flex-no-wrap h-full', theme.submenu.backgroundColorClassName, theme.submenu.textColorClassName),
        width: theme.submenu.drawerWidth,
        backdropStyles: {
            opacity: 0
        },
        children: [
            /*#__PURE__*/ jsx(DrawerHeader, {
                title: title,
                onDismiss: onDismiss,
                onGoBack: onGoBack,
                isNew: isNew
            }),
            /*#__PURE__*/ jsx("div", {
                className: "flex flex-col flex-1 h-full overflow-auto",
                children: children
            })
        ]
    });
};
const ui_MainMenuDrawer = MainMenuDrawer;
export default ui_MainMenuDrawer;
